module.exports = __webpack_public_path__ + "static/media/shape_violet.01e187a0.svg";